<div class="legend">
  @for (item of items(); track item.token) {
    <div class="legend__item">
      <span
        class="legend__dot"
        [ngClass]="'legend__dot--' + item.variant"
      ></span>

      <span class="legend__label mat-body-medium">
        {{ item.defaultText | translate : item.token : item.scope }}
      </span>
    </div>
  }
</div>
